module.exports = __webpack_public_path__ + "static/img/special-price-red-bag.a2ccc22.gif";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/welfare/special-price-red-bag.gif
// module id = aDeB
// module chunks = 215